<template>

  <div class="leaderboard-overlay">

    <transition appear name="bounce">
      <div v-show="open" class="leaderboard-wrapper">
        <div class="dark-background" v-on:click="backClicked"/>
        <div class="content">
          <!--<AngledBackground></AngledBackground>-->
          <div class="loader">
            <LoadIcon :show="showLoader"/>
          </div>
          <div class="ratio-content">
            <button class="btn close-button" v-on:click="backClicked"/>
            <img class="background" src="@/assets/image/leaderboard/frame_leaderboard.svg">
            <img class="background reverse" src="@/assets/image/leaderboard/frame_leaderboard.svg">
            <img v-show="schoolOpen" class="background above"
                 src="@/assets/image/leaderboard/frame_leaderboard.svg">
            <div class="header-buttons">
              <button class="button" @click="toggleViewClicked">VLAANDEREN</button>
              <button class="button" @click="toggleViewClicked">SCHOOL</button>
            </div>
            <div v-show="!schoolOpen" class="leaderboard-content vlaanderen">
              <div class="leaderboard-board">
                <div class="leaderboard-scroll">
                  <div class="header-row">
                    <p class="index">#</p>
                    <p class="buddyName">Buddy</p>
                    <p class="activityCount">Activiteiten</p>
                    <p class="school">School</p>
                    <p class="city">Gemeente</p>
                  </div>
                  <LeaderboardRow v-for="(info,index) in leaderboardData" :show="!schoolOpen" :set="'vlaanderen'"
                                  :key="'vl'+index" :index="index" :class="info?.isBuddy? 'isSelf' : ''"
                                  :info="info"></LeaderboardRow>

                </div>
              </div>
            </div>

            <div v-show="schoolOpen" class="leaderboard-content school">
              <div class="buddy-view">
                <LeaderboardBuddy v-if="buddy.id !== null" :buddy="buddy"></LeaderboardBuddy>
              </div>
              <div class="leaderboard-board">
                <div class="leaderboard-scroll">
                  <div class="header-row">
                    <p class="index">#</p>
                    <p class="buddyName">Buddy</p>
                    <p class="activityCount">Activiteiten</p>
                    <p class="class">Klas</p>
                  </div>
                  <LeaderboardRow v-for="(info,index) in schoolLeaderboardData" :show="schoolOpen" :set="'school'"
                                  :key="'s'+info.index" :index="index" :buddy="buddy"
                                  :info="info"></LeaderboardRow>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </transition>
  </div>

</template>

<script>
import LeaderboardRow from "@/components/StudentPlatform/Leaderboard/LeaderboardRow.vue";
import LeaderboardBuddy from "@/components/StudentPlatform/Leaderboard/LeaderboardBuddy.vue";
import {LeaderboardApi} from "sandpiper_api";
import school from "sandpiper_api/src/model/School";
import LoadIcon from "@/components/StudentPlatform/LoadIcon.vue";

export default {
  name: "LeaderboardOverlay",
  components: {
    LoadIcon,
    LeaderboardBuddy,
    LeaderboardRow
    /*AngledBackground,*/
  },
  inject: ["doApiRequest"],
  mixins: [],
  props: {
    open: Boolean,
    buddy: Object,
  },
  watch: {
    leaderboardData: {
      handler() {
        console.log("leaderboardData changed", this.leaderboardData);
        this.showLoader = false;
        this.scrollToSelf();
      },
      deep: true,
    },
  },
  data() {
    return {
      show: this.open,
      schoolOpen: false,
      selectedBuddy: null,
      leaderboardData: null,
      exampleVlaanderenLeaderboard: [
        {
          "index": 0,
          "buddyName": "Geoff",
          "buddyId": 1,
          "activityCount": 359,
          "class": "Cartaklas",
          "school": "Drongelaarse school",
          "city": "Drongen"
        },
        {
          "index": 1,
          "buddyName": "Bob",
          "buddyId": 2,
          "activityCount": 354,
          "class": "Drongense klakkers",
          "school": "Drongelaarse school",
          "city": "Drongen"
        },
        {
          "index": 2,
          "buddyName": "Alice",
          "buddyId": 3,
          "activityCount": 331,
          "class": "Wiezewee",
          "school": "Drongelaarse school",
          "city": "Drongen"
        },
        {
          "index": 3,
          "buddyName": "Robert",
          "buddyId": 4,
          "activityCount": 329,
          "class": "Erstevier",
          "school": "Drongelaarse school",
          "city": "Drongen"
        },
        {
          "index": 4,
          "buddyName": "efeaf",
          "buddyId": 5,
          "activityCount": 322,
          "class": "Klashier",
          "school": "Schooldaar",
          "city": "Brussel"
        },
        {
          "index": 5,
          "buddyName": "Gerard",
          "buddyId": 6,
          "activityCount": 320,
          "class": "Buddyvriendelijk",
          "school": "Drongelaarse school",
          "city": "Drongen"
        },
        {
          "index": 665,
          "buddyName": "Berend",
          "buddyId": 7,
          "activityCount": 317,
          "class": "Mijn klas",
          "school": "Mijn school",
          "city": "Antwerpen",
          "isSelf": true,
        },
        {
          "index": 665,
          "buddyName": "Berend",
          "buddyId": 7,
          "activityCount": 317,
          "class": "Mijn klas",
          "school": "Mijn school",
          "city": "Antwerpen",
          "isSelf": true,
        },
        {
          "index": 665,
          "buddyName": "Berend",
          "buddyId": 7,
          "activityCount": 317,
          "class": "Mijn klas",
          "school": "Mijn school",
          "city": "Antwerpen",
          "isSelf": true,
        },
        {
          "index": 665,
          "buddyName": "Berend",
          "buddyId": 7,
          "activityCount": 317,
          "class": "Mijn klas",
          "school": "Mijn school",
          "city": "Antwerpen",
          "isSelf": true,
        },
        {
          "index": 665,
          "buddyName": "Berend",
          "buddyId": 7,
          "activityCount": 317,
          "class": "Mijn klas",
          "school": "Mijn school",
          "city": "Antwerpen",
          "isSelf": true,
        },
        {
          "index": 665,
          "buddyName": "Berend",
          "buddyId": 7,
          "activityCount": 317,
          "class": "Mijn klas",
          "school": "Mijn school",
          "city": "Antwerpen",
          "isSelf": true,
        },
        {
          "index": 665,
          "buddyName": "Berend",
          "buddyId": 7,
          "activityCount": 317,
          "class": "Mijn klas",
          "school": "Mijn school",
          "city": "Antwerpen",
          "isSelf": true,
        },
        {
          "index": 665,
          "buddyName": "Berend",
          "buddyId": 7,
          "activityCount": 317,
          "class": "Mijn klas",
          "school": "Mijn school",
          "city": "Antwerpen",
          "isSelf": true,
        },
        {
          "index": 665,
          "buddyName": "Berend",
          "buddyId": 7,
          "activityCount": 317,
          "class": "Mijn klas",
          "school": "Mijn school",
          "city": "Antwerpen",
          "isSelf": true,
        },
        {
          "index": 665,
          "buddyName": "Berend",
          "buddyId": 7,
          "activityCount": 317,
          "class": "Mijn klas",
          "school": "Mijn school",
          "city": "Antwerpen",
          "isSelf": true,
        },
      ],
      showLoader: true,
    }
  },
  computed: {
    school() {
      return school
    },
    schoolLeaderboardData() {
      if (!this.leaderboardData) return [];

      let schoolLeaderboard = [];
      this.leaderboardData.forEach((item) => {
        if (this.buddy.buddyConfig.school.id === item.schoolId) {
          schoolLeaderboard.push(item);
        }
      });

      return this.sortAndIndex(schoolLeaderboard);
    }
  },
  methods: {

    backClicked() {
      this.$emit("backClicked");
    },
    toggleViewClicked() {
      this.schoolOpen = !this.schoolOpen;
    },
    scrollToSelf() {
      this.$nextTick(() => {
        const el = this.$el.querySelector('.isSelf')
        if (!el) return

        // Option A: smooth scroll
        el.scrollIntoView({behavior: 'smooth', block: 'center'})


      })
    },
    async getLeaderboardData() {

      await this.$nextTick();
      await this.$nextTick();
      await this.$nextTick();
      await this.$nextTick();

      if (!this.buddy?.id) return [];

      //console.log("[2026] fetching leaderboard with buddy id " + this.buddy.id);
      let leaderboard = await this.doApiRequest(() => new LeaderboardApi().getLeaderboard(this.buddy.id));
      this.leaderboardData = this.sortAndIndex(leaderboard);
      //console.log(this.leaderboardData);
    },

    sortAndIndex(items) {
      const sorted = [...items].sort((a, b) => b.activityCount - a.activityCount);

      sorted.forEach((item, index) => {
        item.index = index;   // largest gets index 0
      });

      return sorted;
    }


  },

  mounted() {
    //this.updateScale()
    //window.addEventListener('resize', this.updateScale);
    console.log("[2026] LeaderboardOverlay mounted, fetching leaderboard");
    console.log(this.buddy)
    if (this.buddy?.id) {
      this.getLeaderboardData();
    }

    this.scrollToSelf();
  },
  beforeUnmount() {
    // window.removeEventListener('resize', this.updateScale)

  },
  created() {

  },
  updated() {
    this.scrollToSelf()
  },

}


</script>

<style lang="scss" scoped>

@mixin aspect-ratio($width, $height) {
  position: relative;
  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: ($height / $width) * 100%;
  }
  > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.leaderboard-overlay {
  width: 100vw;
  height: 100vh;
  position: absolute;
  //background-color: rgb(37, 38, 66);
  z-index: 1;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.leaderboard-wrapper {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.back-button {
  width: 100px;
  height: 100px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50px;
  top: 25px;
  background-image: url("~@/assets/image/button/bb_button_square.svg");

  span {
    display: block;
    width: 70%;
    height: 70%;
    background-image: $back-icon;
    background-position: center;
    background-size: contain;
  }

}

.bounce-enter-active {
  animation: bounce-in 1s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

.background {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -2;

  &.reverse {
    -webkit-transform: scale(-1, 1);
    -moz-transform: scale(-1, 1);
    -o-transform: scale(-1, 1);
    transform: scale(-1, 1);
  }

  &.above {
    z-index: -1;
  }
}

.dark-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: -3;
}

.content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  //height: 100%;
  aspect-ratio: 1879.25/964.06;
  position: relative;
  --h: 100%;

  @media (max-width: 1499px) {
    max-width: 900px;
  }

  @media (max-width: 1999px) and (min-width: 1500px) {
    max-width: 1400px;
  }

  @media (min-width: 2000px) {
    max-width: 1920px;
  }


}

.ratio-content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  //font-size: calc(3vw / (1879.25 / 964.06));
  padding: 0 3% 3% 3%;
}

.header-buttons {
  display: flex;
  flex-direction: row;
  height: 9%;
  width: 100%;
  padding: 1.5% 3%;

  .button {
    all: unset;
    text-align: center;
    width: 50%;
    height: 100%;
    font-size: 1em;

    font-family: "Flanders Art Sans", sans-serif;
    font-weight: bold;
    color: white;
  }
}

.leaderboard-content {
  width: 100%;
  height: 100%;

  .loading-icon {
    background-color: rgba(0, 0, 0, 0) !important;
    width: 50% !important;
  }

  &.vlaanderen {
    //background-color: red;  
  }

  &.school {
    //background-color: green;
    display: flex;
    flex-direction: row;

    .buddy-view {
      width: 40%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

    }

    .leaderboard-content {
      width: 60%;
    }
  }
}

.header-row {
  display: flex;
  align-items: center;
  width: 100%;
  height: 10%;
  padding: 1%;

  p {
    font-family: "Flanders Art Sans", sans-serif;
    font-weight: bold;
    color: #fff;
    margin: 0 0 0 1%;
    font-size: 0.9em;

    @media (max-width: 1499px) {
      font-size: 0.9em;
    }

    @media (max-width: 1999px) and (min-width: 1500px) {
      font-size: 1.1em;
    }

    @media (min-width: 2000px) {
      font-size: 1.3em;
    }
    
  }


}

.leaderboard-content.vlaanderen {
  p {
    padding-left: 1%;
  }
  
  .header-row {

    .index {
      width: 5%;
    }

    .buddyName {
      width: 25%;
    }

    .activityCount {
      width: 12%;
    }

    .school {
      width: 40%;
    }

    .city {
      width: 18%;
    }
  }
}

.leaderboard-content.school {
  .header-row {

    p {
      padding-left: 1%;
    }

    .index {
      width: 5%;
    }

    .buddyName {
      width: 30%;
    }

    .activityCount {
      width: 15%;
    }


    .class {
      width: 50%;
    }
  }
}

.leaderboard-board {
  position: relative;
  width: 100%;
  height: 100%; /* fills container */
  overflow: hidden; /* prevents outer scroll */
}

/* Inner scroll container */
.leaderboard-scroll {
  position: absolute;
  inset: 0;
  overflow-y: auto; /* inner scroll */
  overflow-x: hidden;
  padding-right: 12px; /* space for custom scrollbar */
}

/* Custom scrollbar */
.leaderboard-scroll::-webkit-scrollbar {
  width: 10px;
}

.leaderboard-scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.leaderboard-scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}

.leaderboard-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.7);
}


@keyframes bounce-in {
  0% {
    transform: translateY(100vh);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(0);
  }
}

.close-button {
  width: 60px;
  height: 60px;
  position: absolute;
  right: -1%;
  top: -1%;
  background-image: url("~@/assets/image/button/bb_button_close.svg");
}

.loader {
  width: 50%;
  height: 50%;
}

</style>